<div class="page">
    <div class="page_header">
        <h1 class="page_title">{{ 'Valores de Premiação' | translate }}</h1>
        <div class="page_action" style="gap: 20px">
            <a href="javascript:void(0);" (click)="newAward()" class="page_action_excel btn btn-warning" type="button">
                <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
                <span class="ml-2 font-weight-normal">{{ 'newValue' | translate }}</span>
            </a>
        </div>
    </div>

    <div class="page_padding">

        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                    <tr>
                        <th scope="col" class="w-10"></th>
                        <th scope="col">{{ 'Pontuação Máxima' | translate }}</th>
                        <th scope="col">{{ 'Valor Individual' | translate }}</th>
                        <th scope="col">{{ 'Valor em Equipe' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let award of awards">
                        <td style="width: 150px">
                            <div class="d-flex justify-content-center" style="gap: 15px">
                                <svg-icon class="is-cursor" (click)="editAward(award)"
                                    src="assets/svg/edit.svg"></svg-icon>
                                <svg-icon class="is-cursor" (click)="deleteAward(award.id)"
                                    src="assets/svg/close-circle.svg"></svg-icon>
                            </div>
                        </td>
                        <td>{{ award.maxPoints }}</td>
                        <td>{{ award.individualValue }}</td>
                        <td>{{ award.teamValue }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="modalAward" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 560px" role="document">
        <div class="modal-content modal-user">
            <div class="modal-header">
                <h2 class="modal-user_title">{{ 'Valores de Premiação' | translate }}</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-user_body">
                <div class="modal-user_card">
                    <fieldset class="custom__form" autocomplete="off">
                        <div class="row">
                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <input [(ngModel)]="awardData.maxPoints" class="form-control" name="valueMin"
                                        type="number" required min="0" step="any" />
                                    <label for="valueMin">{{ 'Pontuação Máxima' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <input [(ngModel)]="awardData.individualValue" class="form-control"
                                        name="individualValue" type="number" required min="0" step="any" />
                                    <label for="individualValue">{{ 'Valor Individual' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <input [(ngModel)]="awardData.teamValue" class="form-control" name="teamValue"
                                        type="number" required min="0" step="any" />
                                    <label for="teamValue">{{ 'Valor em Equipe' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <a class="btn btn-block btn-lg btn-primary text-warning" (click)="saveAward()">
                                    {{ 'SALVAR' | translate }}
                                </a>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>